import type { GamificationStats } from '@testflow/shared';
import { request } from './api.js';

const base = (p: string) => `/v1/projects/${p}`;

export const gamificationApi = {
  stats(projectId: string, testPlanId: string): Promise<GamificationStats> {
    return request<GamificationStats>(
      `${base(projectId)}/gamification/stats?test_plan_id=${testPlanId}`,
    );
  },
};
